module.exports = __webpack_public_path__ + "static/img/share.c00cbfb4.png";